import { useTranslation } from 'react-i18next'

//Utils
import { sanitizeText, sanitizeUrl } from '@/utils/sanitization'

//types
import type { MessageSourceProps } from './types/MessageSourceTypes'

//components
import { Accordion, Link } from '@bosch/react-frok'
import CustomMarkdown from '../CustomMarkdown/CustomMarkdown'

import './MessageSource.scss'

export const MessageSource = ({ source, config }: MessageSourceProps) => {
    const { t } = useTranslation()
    const { link } = source
    const sanitizedLink = link && link !== 'undefined' && link !== 'None' ? sanitizeUrl(link) : null

    const getLabel = (content: unknown, transform?: (v: string) => string): string => {
        if (content === 'undefined' || content === undefined) return 'N/A'
        const sanitized = typeof content === 'string' ? sanitizeText(content) : ''
        return transform ? transform(sanitized) : sanitized
    }

    const buildHeadline = (source: MessageSourceProps['source']): string => {
        return config
            .map((item) => {
                const value = getLabel(source[item.key], item.transform)
                return item.prefix ? `${item.prefix}: ${value}` : value
            })
            .join(' | ')
    }

    return (
        <Accordion
            className="sources-accordion"
            size="small"
            headline={buildHeadline(source)}
        >
            <CustomMarkdown className="sources-content">
                {getLabel(source.text)}
            </CustomMarkdown>
            {sanitizedLink && (
                <Link
                    className="source-link"
                    href={sanitizedLink}
                    target='_blank'
                    icon="externallink"
                    label={t('chat:sourceLink')}
                />
            )}
        </Accordion>
    )
}
